const validateEditorState = (editorState) => {
  const result = [];

  if (!editorState.email) {
    result.push({
      param: 'email',
      userMessage: 'Pole wymagane',
    });
  }

  if (!editorState.password) {
    result.push({
      param: 'password',
      userMessage: 'Pole wymagane',
    });
  }

  return result.length > 0 ? result : null;
};

export default validateEditorState;
